// ** Component Imports

// Direct path, not the shared/ui barrel (keeps the barrel out of the entry chunk)
import { Loader } from '../Loader'

// ** Styled Components
import { LoaderWrapper } from './styles'

// ** Type Imports
import { type CSSProperties } from 'react'

interface Props {
	fullHeight?: boolean
	styles?: CSSProperties
}

export const FallbackLoader = ({ fullHeight = true, styles }: Props) => {
	return (
		<LoaderWrapper $fullHeight={fullHeight} $styles={styles}>
			<Loader />
		</LoaderWrapper>
	)
}
